import { barksApi } from '../api/bark';
import type { BarkItemWithContent, QueueParams } from '../types';
import { localDate } from './barkSchedule';
export function calendarDays(selected: string, wide: boolean): Date[] {
  const date = new Date(`${selected}T12:00`);
  const start = new Date(date.getFullYear(), date.getMonth(), wide ? 1 : date.getDate());
  start.setDate(start.getDate() - (start.getDay() + 6) % 7);
  return Array.from({ length: wide ? 42 : 7 }, (_, index) => new Date(start.getFullYear(), start.getMonth(), start.getDate() + index));
}
export const deliveryDay = (item: BarkItemWithContent) => item.status === 'pending' && !item.scheduled_for ? null : localDate(new Date(item.scheduled_for || item.sent_at || item.created_at));
/** The endpoint caps each page at1000; drain its existing offset pages before displaying a complete interval. */
export async function loadBarkInterval(siteSlug: string, params: QueueParams, signal?: AbortSignal): Promise<BarkItemWithContent[]> {
  const items: BarkItemWithContent[] = [];
  const ids = new Set<string>();
  for (let offset = 0; ; offset += 1000) {
    if (signal?.aborted) throw new Error('Calendar loading cancelled.');
    const result = await barksApi.listQueue(siteSlug, { ...params, limit: 1000, offset });
    if (!result.success || !result.data) throw new Error(result.error?.message ?? 'Could not load scheduled deliveries.');
    for (const item of result.data) {
      if (ids.has(item.id)) throw new Error('The calendar changed while loading. Refresh to try again.');
      ids.add(item.id); items.push(item);
    }
    if (result.data.length < 1000) return items;
  }
}
